import { render, staticRenderFns } from "./CVUpload.vue?vue&type=template&id=25ecbb32&scoped=true"
import script from "./CVUpload.vue?vue&type=script&lang=ts"
export * from "./CVUpload.vue?vue&type=script&lang=ts"
import style0 from "./CVUpload.vue?vue&type=style&index=0&id=25ecbb32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ecbb32",
  null
  
)

export default component.exports